import {useTranslation} from "react-i18next";
import Icon from "@mui/material/Icon";
import {useAuth} from "../../auth/AuthProvider";


export const useSidenavRoutes = () => {
    const {t} = useTranslation(['layouts']);
    const {workgroupAuthorization} = useAuth();
    
    return [
        {
            type: "collapse",
            name: t("sidenav.dashboard"),
            key: "dashboard",
            icon: <Icon fontSize="small">dashboard</Icon>,
            route: "/dashboard",
        },
        {
            type: "collapse",
            name: t("sidenav.models1"),
            key: "models1",
            icon: <Icon fontSize="small">straighten</Icon>,
            route: "/models1",
            hidden: !workgroupAuthorization.models1.read
        },
        {
            type: "collapse",
            name: t("sidenav.models23"),
            key: "models23",
            icon: <Icon fontSize="small">ac_unit</Icon>,
            route: "/models23",
            hidden: !workgroupAuthorization.models23.read
        },
        {
            type: "collapse",
            name: t("sidenav.incidents"),
            key: "incidents",
            icon: <Icon fontSize="small">report</Icon>,
            route: "/incidents",
            hidden: !workgroupAuthorization.incidents.read
        },
        {
            type: "collapse",
            name: t("sidenav.analytics"),
            key: "analytics",
            icon: <Icon fontSize="small">analytics</Icon>,
            route: "/analytics",
            hidden: false,
        },
        {
            type: "collapse",
            name: t("sidenav.stations"),
            key: "stations",
            icon: <Icon fontSize="small">device_thermostat</Icon>,
            route: "/stations",
            hidden: !workgroupAuthorization.stations.read
        },
        {
            type: "collapse",
            name: t("sidenav.users"),
            key: "users",
            icon: <Icon fontSize="small">people</Icon>,
            route: "/users",
            hidden: !workgroupAuthorization.users.read
        },
        {
            type: "collapse",
            name: t("sidenav.groups"),
            key: "groups",
            icon: <Icon fontSize="small">groups</Icon>,
            route: "/groups",
            hidden: !workgroupAuthorization.groups.read
        },
        {
            type: "collapse",
            name: t("sidenav.importTasks"),
            key: "importTasks",
            icon: <Icon fontSize="small">cloud_upload</Icon>,
            route: "/importTasks",
            hidden: !workgroupAuthorization.importTasks.read
        },
        {
            type: "collapse",
            name: t("sidenav.workgroups"),
            key: "workgroups",
            icon: <Icon fontSize="small">group_work</Icon>,
            route: "/workgroups",
            hidden: !workgroupAuthorization.workgroups.read
        }
    ].filter(route => !route.hidden);
}

export default useSidenavRoutes;